import { EntityHoliday } from "../../entity/EntityHoliday";

export class DtoHolidaysPostRes extends EntityHoliday {}
